// extracted by mini-css-extract-plugin
module.exports = {"loading":"AssessmentList_loading__3lDKp","container":"AssessmentList_container__3hBc_"};